
import {React , useEffect, useState} from 'react';
import AOS from 'aos';
import { Route, Routes } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import VideoSplash from './components/VideoSplash';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';

import routes from './pages';
import Page404 from './pages/404';

import '../src/assets/binasea.css';
import '../src/assets/font-awesome.css';

function App() {
    const [showSplash, setShowSplash] = useState(true);
    const [hasSeenSplash, setHasSeenSplash] = useState(false);

    useEffect(() => {
        const seen = sessionStorage.getItem('videoSplashSeen');
        if (seen) {
            setShowSplash(false);
            setHasSeenSplash(true);
        }
    }, []);

    const handleSplashComplete = () => {
        sessionStorage.setItem('videoSplashSeen', 'true');
        setShowSplash(false);
        setHasSeenSplash(true);
    };

    useEffect(() => {
        AOS.init({
          duration : 2000
        }); 
      }, []);

    useEffect(() => {
        // eslint-disable-next-line no-use-before-define
        var Tawk_API = Tawk_API || {};
        // eslint-disable-next-line no-unused-vars
        var Tawk_LoadStart = new Date();
        
        // Configure widget to appear on the left side
        Tawk_API.customStyle = {
            visibility : {
                desktop : {
                    position : 'bl',
                    xOffset : 20,
                    yOffset : 20
                },
                mobile : {
                    position : 'bl',
                    xOffset : 10,
                    yOffset : 10
                }
            }
        };
        
        var s1 = document.createElement("script");
        var s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/69d43d6dfd6e731c34ee2c1e/1jligvtc4';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
    }, []);

    return (
        <AuthProvider>
            <CurrencyProvider>
                <CartProvider>
                    {showSplash && <VideoSplash onComplete={handleSplashComplete} />}
                    
                    {hasSeenSplash && (
                        <>
                            <Header />

                            <Routes>

                                {
                                    routes.map((data,idx) => (
                                        <Route key={idx} path={data.path} element={data.component} exact />
                                    ))
                                }

                                <Route path='*' element={<Page404 />} />
                            </Routes>

                            <Footer />
                        </>
                    )}
                </CartProvider>
            </CurrencyProvider>
        </AuthProvider>
    );
}

export default App;
